import { Stack as StackMui, StackProps as StackPropsMui } from '@mui/material';
import { forwardRef } from 'react';

export interface StackProps
  extends Pick<
    StackPropsMui,
    'children' | 'divider' | 'spacing' | 'direction'
  > {
  readonly mb?: string | number;
  readonly mt?: string | number;
  readonly ml?: string | number;
  readonly mr?: string | number;
  readonly pt?: string | number;
  readonly pb?: string | number;
  readonly pl?: string | number;
  readonly pr?: string | number;
  readonly margin?: string | number;
  readonly padding?: string | number;
  readonly width?: string | number;
  readonly alignItems?: StackPropsMui['alignItems'];
}

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    { mb, mt, ml, mr, pt, pb, pl, pr, margin, padding, width, ...rest },
    ref,
  ) => {
    return (
      <StackMui
        {...rest}
        ref={ref}
        sx={{
          marginBottom: mb,
          marginTop: mt,
          marginLeft: ml,
          marginRight: mr,
          paddingTop: pt,
          paddingBottom: pb,
          paddingLeft: pl,
          paddingRight: pr,
          margin,
          padding,
          width,
        }}
      />
    );
  },
);
